module.exports = __webpack_public_path__ + "static/media/17.048093dc.jpg";